export const CONSTS = {
  HEADER: $localize`Remove Device?`,
  BODY: $localize`Are you sure you want to remove the following device?`,
  DRIVER_ID: $localize`Driver ID`,
  EMAIL_ID: $localize`Email`,
  MODEL: $localize`Model`,
};
